/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_Ci as Ci,
  rec_Fo as Fo,
  rec_JSXRuntime as JSXRuntime,
  rec_Ki as Ki,
  rec_Qa as Qa,
  rec_React as React,
  rec_Rr as Rr,
  rec_Za as Za,
  rec_api as api,
  rec_ii as ii,
  rec_jS as jS,
  rec_obtenerUsuario as obtenerUsuario,
} from "../../runtime/index.jsx";
export function ListaAdjuntos({
  entidadTipo: e,
  entidadId: t,
  soloLectura: n,
}) {
  let { confirmar: r } = Fo(),
    [i, a] = (0, React.useState)([]),
    [o, s] = (0, React.useState)(!1),
    [c, l] = (0, React.useState)(``),
    u = (0, React.useRef)(null),
    f = (0, React.useCallback)(() => {
      t &&
        api(`/adjuntos?entidadTipo=${e}&entidadId=${t}`)
          .then(a)
          .catch((e) => l(e.message));
    }, [e, t]);
  if (
    ((0, React.useEffect)(() => {
      f();
    }, [f]),
    !t)
  )
    return null;
  async function p(n) {
    let r = n.target.files?.[0];
    if (r) {
      (s(!0), l(``));
      try {
        let n = new FormData();
        (n.append(`entidadTipo`, e),
          n.append(`entidadId`, String(t)),
          n.append(`nombreUsuario`, obtenerUsuario()?.nombre ?? ``),
          n.append(`archivo`, r));
        let i = await Za(`/adjuntos`, n);
        a((e) => [...e, i]);
      } catch (e) {
        l(e.message);
      } finally {
        (s(!1), u.current && (u.current.value = ``));
      }
    }
  }
  async function m(e) {
    try {
      let t = await Qa(e.urlDescarga),
        n = document.createElement(`a`);
      ((n.href = t),
        (n.download = e.nombreOriginal),
        n.click(),
        setTimeout(() => URL.revokeObjectURL(t), 4e3));
    } catch (e) {
      l(e.message);
    }
  }
  async function h(e) {
    if (
      await r({
        titulo: `Eliminar "${e.nombreOriginal}"`,
        confirmarTexto: `Eliminar`,
        peligro: !0,
      })
    )
      try {
        (await api(`/adjuntos/${e.id}`, {
          method: `DELETE`,
        }),
          a((t) => t.filter((t) => t.id !== e.id)));
      } catch (e) {
        l(e.message);
      }
  }
  return (
    <div
      className={`flex flex-col gap-2`}
      children={[
        <div
          className={`flex items-center justify-between`}
          children={[
            <span
              className={`flex items-center gap-1.5 text-sm font-medium text-(--text-h)`}
              children={[
                <Ci className={`h-4 w-4`} />,
                ` Adjuntos `,
                i.length > 0 && `(${i.length})`,
              ]}
            />,
            !n && (
              <label
                className={`cursor-pointer rounded-full border border-(--border) px-3 py-1 text-xs font-medium text-(--text-h) transition hover:bg-(--accent-bg)`}
                children={[
                  o
                    ? (0, JSXRuntime.jsx)(ii, {
                        className: `inline h-3.5 w-3.5 animate-spin`,
                      })
                    : `Subir archivo`,
                  <input
                    ref={u}
                    type={`file`}
                    className={`hidden`}
                    onChange={p}
                    disabled={o}
                  />,
                ]}
              />
            ),
          ]}
        />,
        c && <p className={`text-xs text-(--error)`} children={c} />,
        i.length > 0 && (
          <ul
            className={`flex flex-col gap-1`}
            children={i.map((e) => (
              <li
                key={e.id}
                className={`flex items-center gap-2 rounded-xl border border-(--border) px-2.5 py-1.5 text-sm`}
                children={[
                  <span
                    className={`min-w-0 flex-1 truncate text-(--text-h)`}
                    children={e.nombreOriginal}
                  />,
                  <span
                    className={`shrink-0 text-xs text-(--text)`}
                    children={jS(e.tamano)}
                  />,
                  <button
                    type={`button`}
                    onClick={() => m(e)}
                    aria-label={`Descargar`}
                    className={`text-(--text) hover:text-(--accent)`}
                    children={<Rr className={`h-4 w-4`} />}
                  />,
                  !n && (
                    <button
                      type={`button`}
                      onClick={() => h(e)}
                      aria-label={`Eliminar`}
                      className={`text-(--text) hover:text-(--error)`}
                      children={<Ki className={`h-4 w-4`} />}
                    />
                  ),
                ]}
              />
            ))}
          />
        ),
      ]}
    />
  );
}
